export default "__VITE_ASSET__CmCVLRig__"